import { createContext } from 'react';
import { InterpreterFrom } from 'xstate';
import { hatcheningMachine } from './state-machine';

export const HatcheningContext = createContext<InterpreterFrom<typeof hatcheningMachine>>(
  undefined!,
);
